"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var pickers_1 = require("@material-ui/pickers");
var date_fns_1 = require("@date-io/date-fns");
var pickers_2 = require("@material-ui/pickers");
var DatePickerInput_1 = require("./DatePickerInput");
var en_AU_1 = require("date-fns/locale/en-AU");
var es_1 = require("date-fns/locale/es");
var zh_CN_1 = require("date-fns/locale/zh-CN");
var useWidgetContext_1 = require("../../../../common/react/useWidgetContext");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var core_1 = require("@material-ui/core");
exports.DatePicker = function (_a) {
    var formData = _a.formData;
    var _b, _c, _d;
    var value = formData.value, rawErrors = formData.rawErrors, uiSchema = formData.uiSchema, options = formData.options;
    var disableFuture = ((_c = (_b = uiSchema) === null || _b === void 0 ? void 0 : _b['ui:options']) === null || _c === void 0 ? void 0 : _c.disableFuture) || ((_d = options) === null || _d === void 0 ? void 0 : _d.disableFuture);
    var _e = react_1.useState(false), isDatePickerOpen = _e[0], setDatePickerOpen = _e[1];
    var currentDateValue = null;
    if (value) {
        currentDateValue = new Date(value);
    }
    var _f = react_1.useState(currentDateValue), selectedDate = _f[0], setNewDate = _f[1];
    var _g = react_1.useState(null), errorMessage = _g[0], setErrorMessage = _g[1];
    var checkout4 = core_1.useTheme().checkoutLite.checkout4;
    var disableCurrentToFutureDate = (checkout4 || {}).disableCurrentToFutureDate;
    var toggleDatePicker = react_1.useCallback(function (value) { return setDatePickerOpen(value); }, [isDatePickerOpen]);
    var locales = {
        'zh-hk': zh_CN_1.default,
        'es-ar': es_1.default,
        'es-cl': es_1.default,
        'es-co': es_1.default,
        'es-pe': es_1.default,
    };
    var configuration = useWidgetContext_1.default().configuration;
    // TODO: split code and load locale based on environment language
    var locale = locales[configuration.dimensions.language] || en_AU_1.default;
    var handleDateChange = react_1.useCallback(function (selectedDate) {
        setErrorMessage(null);
        setNewDate(selectedDate);
    }, []);
    var disableCurrentToOrFutureDate = react_1.useMemo(function () {
        var currentDate = new Date();
        return disableCurrentToFutureDate ? currentDate.setDate(new Date().getDate() - 1) : currentDate;
    }, [disableCurrentToFutureDate]);
    react_1.useEffect(function () {
        var _a;
        var currentError = ((_a = rawErrors) === null || _a === void 0 ? void 0 : _a.length) > 0 && rawErrors[0];
        if (!!currentError) {
            setErrorMessage(currentError);
        }
    }, [rawErrors]);
    return (<pickers_1.MuiPickersUtilsProvider locale={locale} utils={date_fns_1.default}>
      <pickers_2.KeyboardDatePicker clearable={true} open={isDatePickerOpen} onClose={function () { return toggleDatePicker(false); }} value={selectedDate} onChange={handleDateChange} disableFuture={disableFuture} minDate={disableFuture ? undefined : new Date()} maxDate={disableFuture ? disableCurrentToOrFutureDate : undefined} format="yyyy/MM/dd" inputProps={{
        'data-test': disableFuture ? 'checkout:enquiry:datepicker:disableFuture' : undefined,
    }} TextFieldComponent={function (props) {
        return DatePickerInput_1.default({
            schemaField: { props: props, formData: formData },
            toggleDatePicker: toggleDatePicker,
            errorMessage: errorMessage,
        });
    }} okLabel={<Translation_1.default id="trans__checkout__enquiry_form__date_ok_button"/>} cancelLabel={<Translation_1.default id="trans__checkout__enquiry_form__date_cancel_button"/>} clearLabel={<Translation_1.default id="trans__checkout__enquiry_form__date_clear_button"/>}/>
    </pickers_1.MuiPickersUtilsProvider>);
};
exports.default = exports.DatePicker;
